import AzImg from '~/components/Atoms/AzImg.vue';
export default {
  __name: 'BlockSocialPostsGraphql',
  props: {
    title: {
      type: String,
      default: ''
    },
    BlockSocialDescription: {
      type: String,
      default: ''
    },
    postsCollection: {
      type: Object | Array,
      default: function _default() {
        return [];
      }
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var listOfPosts = computed(function () {
      var _props$postsCollectio;
      var posts = ((_props$postsCollectio = props.postsCollection) === null || _props$postsCollectio === void 0 ? void 0 : _props$postsCollectio.items) || [];
      var groupedPosts = [];
      for (var i = 0; i < posts.length; i += 2) {
        var pair = [posts[i]];
        if (posts[i + 1]) {
          pair.push(posts[i + 1]);
        }
        groupedPosts.push(pair);
      }
      return groupedPosts;
    });

    /**
     * Generate the asset path for the given icon.
     *
     * @param      {string}  icon    The icon
     * @return     {string}  Path of the asset.
     */
    function generateIconPath(icon) {
      return require("~/assets/images/icons/social/".concat(icon.toLowerCase(), ".svg"));
    }
    return {
      __sfc: true,
      props: props,
      listOfPosts: listOfPosts,
      generateIconPath: generateIconPath,
      AzImg: AzImg
    };
  }
};